import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';

@Injectable()
export class ContentDataService extends BaseService {
    constructor(private http: HttpClient) {
        super();
        //console.log('ContentDataService.constructor');
    }

    public getContentHtml(pageName: string, keyName: string): Observable<any> {
        let apiUrl = environment.apiUrl + '/Content/Html';
        if (environment.mockData) {
            apiUrl = 'mock-data/content-htmls.json';
        }

        this.setHttpOptions();
        this.setHttpParam('brandName', environment.brand);
        this.setHttpParam('pageName', pageName);
        this.setHttpParam('keyName', keyName);

        return this.http.get<any[]>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getContentText(pageName: string): Observable<any> {
        let apiUrl = environment.apiUrl + '/Content/Text';
        if (environment.mockData) {
            apiUrl = 'mock-data/content-texts-' + environment.brand + '.json';
        }

        this.setHttpOptions();
        this.setHttpParam('brandName', environment.brand);
        this.setHttpParam('pageName', pageName);

        return this.http.get<any[]>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getContentTooltips(pageName: string): Observable<any> {
        let apiUrl = environment.apiUrl + '/Content/Tooltips';
        if (environment.mockData) {
            apiUrl = 'mock-data/content-tooltips.json';
        }

        this.setHttpOptions();
        this.setHttpParam('brandName', environment.brand);
        this.setHttpParam('pageName', pageName);

        return this.http.get<any[]>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getContentImages(pageName: string): Observable<any> {
        const apiUrl = environment.apiUrl + '/Content/Images';
        if (environment.mockData) {
            //apiUrl = 'mock-data/content-images.json';
        }

        this.setHttpOptions();
        this.setHttpParam('brandName', environment.brand);
        this.setHttpParam('pageName', pageName);

        return this.http.get<any[]>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }
}
